// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__21B0e","icon":"SortAdornment_icon__1qXvD","up":"SortAdornment_up__2v6kX","down":"SortAdornment_down__1ZhJK","active":"SortAdornment_active__oEkq8"};